// extracted by mini-css-extract-plugin
module.exports = {"day":"CustomCalendarDay_day___iD2y"};